import { render, staticRenderFns } from "./NuevoCobro.vue?vue&type=template&id=7e292ee8&scoped=true"
import script from "./NuevoCobro.vue?vue&type=script&lang=js"
export * from "./NuevoCobro.vue?vue&type=script&lang=js"
import style0 from "./NuevoCobro.vue?vue&type=style&index=0&id=7e292ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e292ee8",
  null
  
)

export default component.exports